import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Route, Routes } from "react-router-dom";
import {
  AddIcon
  // ClockCardIcon,
  // LocationCardIcon,
  // ReviewCardIcon
} from "../../Assets/assets";
import BreadCrumbs from "../../Components/BreadCrumbs/BreadCrumbs";
import Button from "../../Components/Button/Button";
// import { GraphCard, InfoCard, LegendCard } from "../../Components/Cards/Cards";
import CreateWorkforce from "../../Components/CreateWorkforce/CreateWorkforce";
import MultipleSelect from "../../Components/Filters/MultipleSelect";
// import { DoughnutChart } from "../../Components/Graphs/DoughnutChart";
// import LineChart from "../../Components/Graphs/LineChart";
import WorkforcePreview from "../../Components/Previews/WorkforcePreview";
import SearchBox from "../../Components/SearchBox/SearchBox";
import Table from "../../Components/Table/Table";
import { useResizeObserver } from "../../CustomHooks/useResizeObserver";
import { setErrorStatus } from "../../Redux/status/action";
import {
  getReferencePictureAsset,
  getSelectedEmployeeCapture
} from "../../Redux/surveillance/action";
import {
  setSelectedTableData,
  setTableFilter,
  setTableSearchKey,
  setTableSort
} from "../../Redux/table/action";
import { createEmployee, editEmployee } from "../../Redux/workforce/action";
import { isValidObject } from "../../Services/validators";
import {
  convertWorkforceToTableData,
  defaultWorkforceFilter,
  workforceFilterData,
  workforceTableField,
  workforceTableHeadings
} from "../../Utils/Constants/Calls";
import { FilterSeparator } from "../../Utils/Constants/Constants";

export const Calls = (props) => {
  const [selectedFilters, setSelectedFilters] = useState(
    defaultWorkforceFilter
  );
  const [collapse, setCollapse] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const filterContainerRef = useRef(null);
  const tableContainerRef = useRef(null);
  const { height } = useResizeObserver(filterContainerRef);

  useEffect(() => {
    setSelectedFilters(props.table.workforce.filter);
  }, [props.table.workforce.filter]);

  const handleApplyClick = () => {
    props.setTableFilter("CALLS", selectedFilters);
  };

  const handleResetClick = (key) => {
    setSelectedFilters({
      ...selectedFilters,
      [key]: defaultWorkforceFilter[key]
    });
    props.setTableFilter("CALLS", {
      ...selectedFilters,
      [key]: defaultWorkforceFilter[key]
    });
  };

  const handleClearClick = () => {
    props.setTableFilter("CALLS", defaultWorkforceFilter);
    props.setTableSearchKey("CALLS", "");
    setSelectedFilters(defaultWorkforceFilter);
  };

  const getCapturePictureData = () => {
    if (isValidObject(props.surveillance.captures)) {
      return Object.values(props.surveillance.captures)
        .filter(
          (data) => data.employee.id === props.table.workforce?.selectedEmployee
        )
        .sort((a, b) => b.createdAt - a.createdAt);
    } else {
      return [];
    }
  };

  const getReferencePictureData = () => {
    if (isValidObject(props.surveillance.reference)) {
      return Object.values(props.surveillance.reference).find(
        (data) => data.employee?.id === props.table.workforce?.selectedEmployee
      );
    } else {
      return {};
    }
  };

  return (
    <>
      <Routes>
        <Route
          path="/:employeeId"
          element={
            <WorkforcePreview
              navigate={props.navigate}
              setErrorStatus={props.setErrorStatus}
              roles={props.workforce.roles}
              data={
                props.workforce.data?.[props.table.workforce.selectedEmployee]
              }
              surveillanceLoading={props.surveillance.loading}
              referencePictureData={getReferencePictureData()}
              capturePictureData={getCapturePictureData()}
              updateEmployeeData={(data) => {
                props.editEmployee(data);
              }}
              getSelectedEmployeeCapture={(data) =>
                props.getSelectedEmployeeCapture(data)
              }
              getReferencePictureAsset={(data) =>
                props.getReferencePictureAsset(data)
              }
            />
          }
        />
        <Route
          path="/createWorkforce"
          element={
            <CreateWorkforce
              navigate={props.navigate}
              setErrorStatus={props.setErrorStatus}
              roles={props.workforce.roles}
              createNewEmployee={(data, file) => {
                props.createEmployee(data, file);
              }}
            />
          }
        />
      </Routes>
      <div
        className={`inherit-parent-height inherit-parent-width position-relative ${
          !collapse ? "overflow-scroll" : "overflow-hidden"
        }`}
        ref={tableContainerRef}
      >
        <div
          style={
            !collapse
              ? {
                  position: "sticky",
                  top: "0px"
                }
              : {}
          }
          className="inherit-parent-width"
        >
          <div className="display-flex flex-justify-content-space-between flex-align-items-center">
            <BreadCrumbs />
            <div className="display-flex">
              <div className="padding-right-default">
                <Button
                  text="New Employee"
                  data-cy="CREATE-NEW-CALLS-BUTTON"
                  icon={
                    <AddIcon
                      color={
                        props.auth.theme.secondaryColor === "#0E0E0E"
                          ? "#FFFFFF"
                          : "#0E0E0E"
                      }
                    />
                  }
                  onClick={() => {
                    props.navigate("/workforce/createWorkforce");
                  }}
                  className="width-fit-content padding-left-large padding-right-large"
                />
              </div>
            </div>
          </div>

          <div
            ref={filterContainerRef}
            className="padding-top-larger display-flex flex-justify-content-space-between"
          >
            <div
              style={{ width: "90%", flexWrap: "wrap", gap: "8px" }}
              className="display-flex flex-align-items-center"
            >
              <div style={{ width: "200px" }}>
                <SearchBox
                  title="SEARCH CALLS"
                  placeHolder="SEARCH CALLS"
                  value={props.table.workforce.searchKey}
                  onChange={(event) => {
                    props.setTableSearchKey("CALLS", event.target.value);
                  }}
                  showCloseIcon={props.table.workforce.searchKey ? true : false}
                  closeOnClick={() => {
                    if (props.table.workforce.searchKey.length > 0) {
                      props.setTableSearchKey("CALLS", "");
                    }
                  }}
                />
              </div>

              <FilterSeparator />

              <MultipleSelect
                loading={props.workforce.loading}
                data-cy="TYPE-MULTI"
                data={workforceFilterData(props.locations.data)[0]}
                onResetClick={(key) => {
                  handleResetClick(key);
                }}
                setSelectedFilters={setSelectedFilters}
                selectedFilters={selectedFilters}
                appliedFilters={props.table.workforce.filter}
                selected={selectedFilters["type"]}
              />

              <FilterSeparator />

              <MultipleSelect
                loading={props.workforce.loading}
                data-cy="ASSIGNED-LOCATIONS-MULTI"
                data={workforceFilterData(props.locations.data)[1]}
                onResetClick={(key) => {
                  handleResetClick(key);
                }}
                setSelectedFilters={setSelectedFilters}
                selectedFilters={selectedFilters}
                appliedFilters={props.table.workforce.filter}
                selected={selectedFilters["assignedLocations"]}
              />
            </div>

            <div
              style={{
                width: "10%"
              }}
              className={`display-flex flex-justify-content-space-between`}
            >
              <div
                style={{
                  width: "60%"
                }}
              >
                <Button
                  data-cy="FILTER-APPLY-BUTTON"
                  text="Apply"
                  boxShadow={false}
                  variant="filter"
                  loading={props.loading}
                  className="inherit-parent-width padding-left-large padding-right-large"
                  onClick={() => {
                    handleApplyClick();
                  }}
                />
              </div>
              <div
                style={{
                  width: "40%"
                }}
              >
                <Button
                  data-cy="FILTER-RESET-BUTTON"
                  variant="transparent"
                  text="Clear"
                  boxShadow={false}
                  className="inherit-parent-width padding-left-large padding-right-large"
                  onClick={() => {
                    handleClearClick();
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div
          style={
            !collapse
              ? { height: "fit-content" }
              : { height: `calc(100% - ${height + 32}px` }
          }
        >
          {/* {!collapse && (
            <>
              <div className="display-flex flex-justify-content-space-between padding-top-larger">
                {InfoCardData.map((data, index) => (
                  <div key={index} style={{ width: "calc(100% / 3 - 20px)" }}>
                    <InfoCard data={data} />
                  </div>
                ))}
              </div>
              <div className="display-flex flex-justify-content-space-between padding-top-larger ">
                <GraphCard
                  title="STATUS DATA"
                  graph={<DoughnutChart data={sampleDoughnutChartData} />}
                  legend={
                    <div className="display-flex flex-justify-content-center padding-top-large">
                      {sampleDoughnutChartData.datasets[0].backgroundColor.map(
                        (data, i) => (
                          <div key={i}>
                            <LegendCard
                              data={sampleDoughnutChartData}
                              color={data}
                              index={i}
                            />
                          </div>
                        )
                      )}
                    </div>
                  }
                />

                <GraphCard
                  title="KPI HISTORY"
                  comingSoon={true}
                  graph={<DoughnutChart data={sampleDoughnutChartData} />}
                  legend={
                    <div
                      style={{
                        paddingTop: "31px"
                      }}
                    />
                  }
                />

                <GraphCard
                  title="PENALTY HISTORY"
                  comingSoon={true}
                  type="line"
                  graph={<LineChart data={sampleBarChartData} />}
                  legend={
                    <div
                      style={{
                        paddingTop: "31px"
                      }}
                    />
                  }
                />
              </div>
            </>
          )} */}

          {height && (
            <div className="padding-top-larger inherit-parent-height">
              <Table
                title="ALL CALLS"
                setCollapse={(data) => {
                  setCollapse(data);
                  if (tableContainerRef.current) {
                    tableContainerRef.current.scrollTop = 0;
                  }
                }}
                allowCollapse={false}
                collapse={collapse}
                headers={workforceTableHeadings}
                onClick={(data) => {
                  props.setSelectedTableData("CALLS", data.documentId);
                  props.navigate(`workforce/${data.documentId}`);
                }}
                data={
                  isValidObject(props.workforce.data)
                    ? !collapse
                      ? convertWorkforceToTableData(
                          Object.values(props.workforce.data).slice(0, 6)
                        )
                      : convertWorkforceToTableData(
                          Object.values(props.workforce.data)
                        )
                    : []
                }
                getField={workforceTableField}
                totalPage={Math.ceil(props.workforce.total / 50)}
                currentPage={currentPage}
                previousPageOnClick={() => {
                  setCurrentPage(currentPage - 1);
                }}
                nextPageOnClick={() => {
                  setCurrentPage(currentPage + 1);
                }}
                resetAllClick={() => {
                  handleClearClick();
                }}
                sort={props.table.workforce.sort}
                handleSort={(title) => {
                  setCurrentPage(1);
                  props.setTableSort("CALLS", {
                    title: title,
                    ascending:
                      props.table?.workforce?.sort?.title === title
                        ? !props.table?.workforce?.sort?.ascending
                        : true
                  });
                }}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = function(state) {
  return {
    auth: state.auth,
    locations: state.locations,
    surveillance: state.surveillance,
    table: state.table,
    workforce: state.workforce
  };
};

const mapDispatchToProps = function() {
  return {
    setSelectedTableData: (tableName, data) =>
      setSelectedTableData(tableName, data),
    getSelectedEmployeeCapture: (documentId) =>
      getSelectedEmployeeCapture(documentId),
    getReferencePictureAsset: (documentId) =>
      getReferencePictureAsset(documentId),
    editEmployee: (data) => editEmployee(data),
    setTableFilter: (tableName, data) => setTableFilter(tableName, data),
    setTableSort: (tableName, data) => setTableSort(tableName, data),
    setTableSearchKey: (tableName, value) =>
      setTableSearchKey(tableName, value),
    createEmployee: (data, file) => createEmployee(data, file),
    setErrorStatus: (error) => setErrorStatus(error)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Calls);
